module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"filter_by":"Filter by {filterName}"},"fr":{"filter_by":"Filtrer par {filterName}"}}')
  delete Component.options._Ctor
}
